import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/layout/layout.service';
import { WhatsnewService } from './whatsnew.service';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.scss'],
})
export class WhatsNewComponent implements OnInit {
  public data: any = [];

  constructor(
    private whatsNewService: WhatsnewService,
    public layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.populateToolbarData();

    this.whatsNewService.getwhatsnewData().subscribe((res) => {
      this.data = res;
    });
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Whats New ?',
    });
    this.layoutService.setNavbarButtons([]);
  }
}
